import React from 'react';
import { useMutation } from 'react-query';
import { toast } from 'components/Shared/Toast';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, Form, ButtonGroup, FormGroup, Media } from 'reactstrap';

import bootbox from 'components/Modals/Bootbox';
import { useSign, CONTROL_MODAL, SIGNUP_MODAL } from 'context/signview';
import { fetcher } from 'api/client';
import { signup, resendVerificationCode } from 'api/actions/auth';


function SuccessBody({ currentParticipant, handleResendVerificationCode }) {
    const { t } = useTranslation();

    return (
        <div className="media-body container px-5 py-3">
            <div className="text-center">
                <h4 className="font-weight-bold mb-4 text-center">{t('signup.body_text_three')}</h4>
                <div>
                    <span className="text-center text-muted mb-4 text-center">
                        {t('signup.body_text_four', { email: currentParticipant.email })}
                    </span>
                </div>
                <div>
                    <img className="m-1 mb-2 p-1" src="/images/file-sent.png" style={{ width: 120 }} alt="" />
                </div>
                <div className="p-2"><strong>{t('signup.send_again')}</strong></div>
                <Button
                    type="button"
                    className="btn btn-lg btn-primary"
                    onClick={handleResendVerificationCode}>
                    {t('signup.resendVerify')}
                </Button>
            </div>
        </div>
    )
}

function SignUpBody({ register, currentParticipant, isLoading }) {

    const { t } = useTranslation();
    return (
        <div className="media-body container px-5 py-3">
            <div className="text-center rounded-lg p-1 bg-success">
                <i className="fas fa-check-circle text-light" />
                <small className="ml-2 font-weight-bold text-center text-light mb-4 text-center">{t('signup.title')}</small>
            </div>
            <div className="text-center my-3">
                <h4 className="font-weight-bold mb-4 text-center">{t('signup.body_text_one')}</h4>
                <img src="/images/file-in-folder.png" style={{ width: 200 }} alt="" />
                <div>
                    <small className="font-weight-bold text-center text-primary mb-4 text-center">{t('signup.body_text_two')}</small>
                </div>
            </div>

            <Form>
                <FormGroup>
                    <label className="bg-light border-0 rounded-0 pl-0" htmlFor="">Email</label>
                    <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        aria-describedby="emailHelp"
                        placeholder=""
                        ref={register}
                        defaultValue={currentParticipant.email}
                        disabled
                    />
                </FormGroup>
                <FormGroup>
                    <label className="bg-light border-0 rounded-0 pl-0" for="">{t('signup.given_name_label')}</label>
                    <input
                        type="email"
                        className="form-control"
                        id="givenName"
                        name="name"
                        aria-describedby="emailHelp"
                        placeholder=""
                        ref={register}
                        defaultValue={currentParticipant.name}
                    />
                </FormGroup>
                <FormGroup>
                    <label className="bg-light border-0 rounded-0 pl-0" for="">{t('signup.family_name_label')}</label>
                    <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="familyName"
                        aria-describedby="emailHelp"
                        placeholder=""
                        ref={register}
                        defaultValue={currentParticipant.last_name}
                    />
                </FormGroup>
                <FormGroup>
                    <label className="bg-light border-0 rounded-0 pl-0" htmlFor="">{t('signup.password_label')}</label>
                    <input
                        type="password"
                        className="form-control"
                        id="pwd"
                        name="password"
                        placeholder={t('contracts.new.password_placeholder')}
                        ref={register}
                        defaultValue={''}
                        disabled={isLoading}
                    />
                </FormGroup>
                <FormGroup className=" mb-0">
                    <label className="bg-light border-0 rounded-0 pl-0" htmlFor="">{t('signup.confirm_password_label')}</label>
                    <input
                        type="password"
                        className="form-control"
                        id="confirmPwd"
                        name="confirmPassword"
                        placeholder={t('profile.security.confirm_password')}
                        ref={register}
                        defaultValue={''}
                        disabled={isLoading}
                    />
                </FormGroup>
            </Form>
        </div>
    )

}

export default function SignUpModal() {
    const { t, i18n } = useTranslation();
    const [{ modal, contractId, jwt, contract: { signViewOptions: { currentParticipant = {} } = {} } }, dispatch] = useSign();

    const { register, handleSubmit } = useForm({
        defaultValues: {
            email: currentParticipant.email,
            password: '',
            confirmPassword: '',
            givenName: currentParticipant.name,
            familyName: currentParticipant.last_name
        }
    })

    const handleClose = () => {
        dispatch({ type: CONTROL_MODAL, close: SIGNUP_MODAL })
    }

    const { mutate: mutateSignUp, isSuccess, isLoading } = useMutation((payload) => fetcher(signup(payload), jwt), {
        onSuccess: () => {
            //TODO SIGNUP ALERT
            // bootbox.alert({ text: t('ok'), title: t('okkk') });
            handleClose()
        },
        onError: (error) => {
            toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
        },
    })
    const { mutate: mutateResendVerificationCode } = useMutation((payload) => fetcher(resendVerificationCode(payload), jwt), {
        onSuccess: (data) => {
            toast.success(t('Te hemos reenviado el correo'))
        },
        onError: (error) => {
            toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
        },
    })


    const goToStarter = () => {
        window.open('https://starter.trato.io/login')
    }

    const handleSignup = (data) => {
        const { email, password, confirmPassword, givenName, familyName } = data;

        if (email === '' || password === '' || confirmPassword === '' || givenName === '' || familyName === '') {
            return toast.error(t('errors.Required'));
        }

        if (password !== confirmPassword) {
            return toast.error(t('errors.PasswordsMustMatch'));
        }

        if (password.length < 8) {
            return toast.error(t('errors.PasswordTooShot'));
        }

        if (!/[0-9]/.test(password)) {
            return toast.error(t('errors.PasswordNumbersRequired'));
        }

        if (!/[A-Z]/.test(password)) {
            return toast.error(t('errors.MissingUpperCase'));
        }

        if (!/[a-z]/.test(password)) {
            return toast.error(t('errors.MissingLowerCase'));
        }

        const payload = {
            email: email || currentParticipant.email,
            password,
            from: {
                contract: contractId,
            },
            lang: i18n.language ?? window.appLocale ?? 'es',
            givenName,
            familyName
        };

        //   app.request('modals').show(new Success({ message: t('signup.verification_email_sent') }));
        mutateSignUp(payload)
    }

    const handleResendVerificationCode = () => {
        mutateResendVerificationCode({ username: currentParticipant.email })
    }

    const isOpen = modal.includes(SIGNUP_MODAL)// showSignUpModal && email;

    return (

        <Modal isOpen={isOpen} centered>
            <ModalHeader toggle={handleClose}>
                {/* <h4 className="my-0">{t('signup.title')}</h4> */}
            </ModalHeader>
            <ModalBody>
                <Media className="mt-0">
                    {isSuccess ?
                        <SuccessBody
                            currentParticipant={currentParticipant}
                            handleResendVerificationCode={handleResendVerificationCode}
                        />
                        :
                        <SignUpBody
                            register={register}
                            currentParticipant={currentParticipant}
                            isLoading={isLoading}
                        />
                    }
                </Media>
            </ModalBody>
            {
                !isSuccess &&
                <ModalFooter>
                    <ButtonGroup className="d-flex flex-grow-1">
                        <Button
                            color="primary"
                            disabled={isLoading}
                            onClick={handleSubmit(handleSignup)}>{isLoading ? t('editor.info.loading') : t('signup.button')}
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            }
        </Modal>
    )
}
